import {ContentUserProductionRewardDomain} from "../../domain/content/ContentUserProductionRewardDomain"

export const ContentUserProductionRewardDescriptor: Record<keyof ContentUserProductionRewardDomain, (o: ContentUserProductionRewardDomain) => string> = {
    id(o: ContentUserProductionRewardDomain): string {
        return o.id.toString()
    },
    creatorId(o: ContentUserProductionRewardDomain): string {
        return o.creatorId.toString()
    },
    value(o: ContentUserProductionRewardDomain): string {
        return o.value.toString()
    },
    displayOrder(o: ContentUserProductionRewardDomain): string {
        return o.displayOrder.toString()
    },
    createdAt(o: ContentUserProductionRewardDomain): string {
        return o.createdAt.toISOString().substring(0, 19).replace('T', ' ')
    },
    lastModifiedAt(o: ContentUserProductionRewardDomain): string {
        return o.lastModifiedAt?.toISOString().substring(0, 19).replace('T', ' ') ?? '-'
    }
}
